
const FormInputError = ({ message = '', id }) => {
    return (
        <span id={id} data-validation={message} className={`mb-1 ${message.length > 0 ? 'block' : 'hidden'}`} aria-live="polite" role="alert">
            <span className={`transition-all duration-500 text-red text-sm ${message.length > 0 ? 'opacity-100' : 'opacity-0'}`}>{ message }</span>
        </span>
    )
}

export default FormInputError
